import type { IPremiseVehicleNumberArguments } from '@/@types/api/premiseVehicles';

import premiseVehiclesApi from '@/api/premiseVehicles';

export default {
  actions: {
    async getPremiseVehicles(_: any, premiseID: number) {
      try {
        const response = await premiseVehiclesApi.getPremiseVehicles(premiseID);
        return response;
      } catch (error) {
        console.log(error);
      }
    },

    async setPremiseVehicles(_: any, payload: IPremiseVehicleNumberArguments) {
      try {
        const response = await premiseVehiclesApi.setPremiseVehicles(payload);
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
